import { ModelBase } from 'store/model-base';

export class CmsAccountDataPlanCollection extends ModelBase {
    public static storeName: string = 'cmsAccountDataPlanCollection';
    public plans: CmsDataPlanDetails[];
}
